import React, { ReactElement } from 'react';
import QRCode from 'react-qr-code';
import spayd from 'spayd';
import logger from 'utils/helpers/server/logger';

interface Props {
    recipientIBAN: string;
    totalAmountWithVat: number;
    variable_symbol: string | number;
}

const PaymentQRCode = ({
    recipientIBAN,
    totalAmountWithVat,
    variable_symbol,
}: Props): ReactElement => {
    // Could not figure out the IBAN
    let iban = recipientIBAN;
    if (iban === null) {
        return null;
    }

    // Remove IBAN whitespace
    iban = iban.replace(/\s/g, '');

    // Get variable symbol
    const vs = variable_symbol ? variable_symbol + '' : undefined;

    // No variable symbol received
    if (!vs) {
        return null;
    }

    // Test if the variable symbol is digits only
    if (/^\d+$/.test(vs) === false) {
        return null;
    }

    // The payment must not be negative
    totalAmountWithVat = Math.abs(totalAmountWithVat);

    // Check maximum length for the variable symbol
    if (vs.length > 10) {
        return null;
    }

    try {
        return (
            <div className="paymentQrCode" style={{ margin: '1rem' }}>
                <QRCode
                    size={128}
                    value={spayd({
                        acc: iban,
                        am: totalAmountWithVat.toString(),
                        cc: 'CZK',
                        msg: 'FACR',
                        xvs: vs,
                    })}
                />
            </div>
        );
    } catch (error: any) {
        logger.warning(
            'Unable to generate qr-code. Invalid data',
            error.message
        );
    }
    return null;
};

export default PaymentQRCode;
